import React, { useEffect } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { toast } from "react-toastify";
import { companyList } from "../../apis/api/DataApi";
import {getMemberInvoice, insertInvoice}from "../../apis/api/InvoiceApi"
import { useDispatch, useSelector } from "react-redux";
import Cookies from 'js-cookie';

const InvoiceUploadModal = ({ show, handleClose }) => {
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
    reset,
  } = useForm();

  const dispatch = useDispatch();
  const userId = Cookies.get('userID');
  const companyId = Cookies.get('company_id');

  useEffect(() => {
    (async () => {
      try {
        await dispatch(companyList()).unwrap();
      } catch (err) {
        console.error("Failed to fetch companies", err);
      }
    })();
  }, [dispatch]);

  const { CompanyList } = useSelector((state) => state.DataSlice);

  const invoiceStatusOptions = [
    { value: 1, label: "Paid" },
    { value: 0, label: "Unpaid" },
  ];

  const selectedStatus = watch("invoiceStatus");

  
  useEffect(() => {
    if (selectedStatus?.value === "paid") {
      setValue("dueDate", null);
      setValue("reminder", null);
    }
  }, [selectedStatus, setValue]);

  const onSubmit = async(formDataRaw) => {
    const formData = new FormData();

    for (const key in formDataRaw) {
      let value = formDataRaw[key];

      if (typeof value === "object" && value?.value !== undefined) {
        value = value.value;
      }

      if (value instanceof Date) {
        value = value.toISOString();
      }

      if (value instanceof FileList) {
        if (value.length > 0) {
          formData.append(key, value[0]);
        }
        continue;
      }

      formData.append(key, value);
    }
    formData.append('userId', userId);
    formData.append('companyId', companyId);
   const res = await dispatch(insertInvoice(formData))
   dispatch(getMemberInvoice({companyId}));
    toast.success("Invoice uploaded successfully!");
    reset();
    handleClose();
  };

  return (
    <Modal show={show} size="lg" centered onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Upload Invoice</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)} className="p-4 border rounded shadow bg-white">
          <div className="row">

            {/* To Company */}
            <div className="col-md-6 mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">To Company *</Form.Label>
                <Controller
                  name="toCompany"
                  control={control}
                  rules={{ required: "Company is required" }}
                  render={({ field }) => (
                    <Select {...field} options={CompanyList} placeholder="Select Company" />
                  )}
                />
                {errors.toCompany && <div className="text-danger">{errors.toCompany.message}</div>}
              </Form.Group>
            </div>

            {/* Invoice Status */}
            <div className="col-md-6 mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Invoice Status *</Form.Label>
                <Controller
                  name="invoiceStatus"
                  control={control}
                  rules={{ required: "Invoice status is required" }}
                  render={({ field }) => (
                    <Select {...field} options={invoiceStatusOptions} placeholder="Select Status" />
                  )}
                />
                {errors.invoiceStatus && <div className="text-danger">{errors.invoiceStatus.message}</div>}
              </Form.Group>
            </div>

            {/* Invoice Amount */}
            
            <div className="col-md-6 mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Invoice Amount (₹) *</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  placeholder="Enter invoice amount"
                  {...register("amount", {
                    required: "Amount is required",
                    min: { value: 1, message: "Amount must be greater than 0" },
                  })}
                  className={errors.amount ? "is-invalid" : ""}
                />
                {errors.amount && (
                  <div className="text-danger">{errors.amount.message}</div>
                )}
              </Form.Group>
            </div>
            


            {/* Due Date (Only for Unpaid) */}
            {selectedStatus?.value === 0 && (
              <div className="col-md-6 mb-3">
                <Form.Group>
                  <Form.Label className="fw-bold">Due Date *</Form.Label>
                  <Controller
                    name="dueDate"
                    control={control}
                    rules={{ required: "Due date is required for unpaid invoices" }}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        selected={field.value}
                        onChange={field.onChange}
                        className={`form-control ${errors.dueDate ? "is-invalid" : ""}`}
                        placeholderText="Select due date"
                        dateFormat="MM/dd/yyyy"
                        minDate={new Date()}
                      />
                    )}
                  />
                  {errors.dueDate && <div className="text-danger">{errors.dueDate.message}</div>}
                </Form.Group>
              </div>
            )}

            {/* Reminder (Only for Unpaid) */}
            {selectedStatus?.value === 0 && (
              <div className="col-md-6 mb-3">
                <Form.Group>
                  <Form.Label className="fw-bold d-block">Send Reminder *</Form.Label>
                  <div className="d-flex gap-3">
                    <Form.Check
                      type="radio"
                      label="Yes"
                      value="1"
                      {...register("reminder", {
                        required: "Please select reminder option",
                      })}
                    />
                    <Form.Check
                      type="radio"
                      label="No"
                      value="0"
                      {...register("reminder", {
                        required: "Please select reminder option",
                      })}
                    />
                  </div>
                  {errors.reminder && (
                    <div className="text-danger">{errors.reminder.message}</div>
                  )}
                </Form.Group>
              </div>
            )}

            {/* Invoice Upload */}
            <div className="col-12 mb-4">
              <Form.Group>
                <Form.Label className="fw-bold">Upload Invoice *</Form.Label>
                <Controller
                  name="invoiceFile"
                  control={control}
                  rules={{
                    required: "Please upload invoice PDF",
                    validate: {
                      isPdf: (files) => {
                        if (!files || files.length === 0) return true;
                        const file = files[0];
                        const isPdf = file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");
                        return isPdf || "Only PDF files are allowed!";
                      },
                    },
                  }}
                  render={({ field }) => (
                    <div className="invoice-upload-wrapper">
                      <label className="invoice-upload-box">
                        <input
                          type="file"
                          accept=".pdf,application/pdf"
                          className="invoice-hidden-input"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file && file.type !== "application/pdf" && !file.name.toLowerCase().endsWith(".pdf")) {
                              toast.error("Only PDF files are allowed!");
                              e.target.value = "";
                              field.onChange(null);
                              return;
                            }
                            field.onChange(e.target.files);
                          }}
                        />
                        <div className="upload-content">
                          <i className="bi bi-file-earmark-pdf upload-icon"></i>
                          <p className="mb-1">Click to upload invoice PDF</p>
                          <small>Only PDF allowed</small>
                        </div>
                      </label>

                      {field.value && field.value.length > 0 && (
                        <div className="file-preview d-flex justify-content-between align-items-center">
                          <span>📄 {field.value[0].name}</span>
                          <button
                            type="button"
                            className="file-remove-btn"
                            onClick={() => field.onChange(null)}
                          >
                            ✖
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                />
                {errors.invoiceFile && (
                  <div className="text-danger mt-1">{errors.invoiceFile.message}</div>
                )}
              </Form.Group>
            </div>

          </div>

          <div className="text-end mt-3">
            <Button type="submit" variant="primary">
              Upload
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default InvoiceUploadModal;
